<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addTaskPopup">{{ $t('add_task') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$t('name')" v-model="taskSearchParams.name" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <v-select :options="categoryOptions" :reduce="label => label.value" :placeholder="$t('category')" v-model="taskSearchParams.category" class="md:mb-0 mb-3" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <v-select :options="priorityOptions" :reduce="label => label.value" :placeholder="$t('priority')" v-model="taskSearchParams.priority" class="md:mb-0 mb-3" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <v-select :options="progressStatusOptions" :reduce="label => label.value" :placeholder="$t('progress_status')" v-model="taskSearchParams.progress" class="md:mb-0" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadTasks(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="taskDataContainer" :title="$t('tasks')" class="mb-8 vs-con-loading__container">

      <shared-task-list
        :tasks="tasks"
        @customClickEdit="editTaskPopup"
        @customClickDelete="destroy"
      ></shared-task-list>

      <template slot="footer">
        <paginate
          :total="taskPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadTasks"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal :title="$t('add_task')" id="addTask" :active.sync="modals.add" size="xl">
      <shared-task-add
        @addTaskSuccess="addTaskSuccess"
        :categoryOptions="categoryOptions"
        :progressStatusOptions="progressStatusOptions"
        :priorityOptions="priorityOptions"
        :visibilityOptions="visibilityOptions"
        :userOptions="userOptions"
        :projectOptions="projectOptions"
      ></shared-task-add>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addTaskButton" color="primary" type="filled" @click.prevent="addTask">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_task')" id="editTask" :active.sync="modals.edit" size="xl">
      <div id="EditTaskFormContainer" class="vs-con-loading__container">
        <shared-task-edit
          @editTaskSuccess="editTaskSuccess"
          :categoryOptions="categoryOptions"
          :progressStatusOptions="progressStatusOptions"
          :priorityOptions="priorityOptions"
          :visibilityOptions="visibilityOptions"
          :userOptions="userOptions"
          :projectOptions="projectOptions"
        ></shared-task-edit>
        <vs-divider></vs-divider>
        <div class="flex justify-end">
          <vs-button id="editTaskButton" color="primary" type="filled" @click.prevent="editTask">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
// TODO: Make Shared Component for List, Add and Edit (Admin, User Usage)
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedTaskList from '@/views/Shared/Tasks/List'
import SharedTaskAdd from '@/views/Shared/Tasks/Add'
import SharedTaskEdit from '@/views/Shared/Tasks/Edit'
import Task from '@/models/Task'

export default {
  name: 'User.Tasks',
  mixins: [Paginate],
  components: {
    SharedTaskList,
    SharedTaskAdd,
    SharedTaskEdit,
    Modal
  },
  data () {
    return {
      tasks: {},
      taskPages: 0,
      categoryOptions: [],
      progressStatusOptions: [],
      priorityOptions: [],
      visibilityOptions: [],
      userOptions: [],
      projectOptions: [],
      itemPerPage: null,
      taskSearchParams: {
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : '',
        category: typeof this.$route.query.category !== 'undefined' ? Number(this.$route.query.category) : '',
        priority: typeof this.$route.query.priority !== 'undefined' ? Number(this.$route.query.priority) : '',
        progress: typeof this.$route.query.progress !== 'undefined' ? Number(this.$route.query.progress) : ''
      },
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initTaskFormData')
      }
    },
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initTaskFormData')
      }
    }
  },
  mounted () {
    this.loadTasks(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_task_table', this.loadTasks)
  },
  methods: {
    async loadTasks (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#taskDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      this.$router.replace({ query: { ...this.taskSearchParams, page, itemPerPage } })
      const response = await Task.findAll({ ...this.taskSearchParams, page, itemPerPage })
      this.tasks = response.data.data.tasks
      this.taskPages = response.data.meta.pagination.last_page
      this.categoryOptions = response.data.meta.options.categories
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.priorityOptions = response.data.meta.options.priorities
      this.visibilityOptions = response.data.meta.options.visibilities
      this.userOptions = response.data.meta.options.users
      this.projectOptions = response.data.meta.options.projects
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#taskDataContainer > .con-vs-loading')
    },
    addTask () {
      EventBus.$emit('initAddTask')
    },
    addTaskModal () {
      this.modals.add = true
    },
    addTaskPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-task', {}, this.addTaskModal)
    },
    addTaskSuccess () {
      this.loadTasks(this.initialPage)
      this.modals.add = false
    },
    editTask () {
      EventBus.$emit('initUpdateTask')
    },
    editTaskModal (data) {
      this.modals.edit = true
      EventBus.$emit('initEditTask', {id: data.id})
    },
    editTaskPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-task', {id}, this.editTaskModal)
    },
    editTaskSuccess () {
      this.loadTasks(this.initialPage)
      this.modals.edit = false
    },
    async destroy (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Task.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadTasks(this.initialPage)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>

